import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

/** 32px outlined icon button lifted off the content beneath it, e.g. a scroll hint arrow. */
export const RaisedIconButton = styled(IconButton)(({ theme }) => ({
  width: 32,
  height: 32,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: theme.customShadows.dropdown,
  '&:hover': { backgroundColor: theme.palette.background.paper },
}));
